import axios from "axios";
import authService from "../api/authService";

// Get API URL from environment, falling back to a default
const API_URL = import.meta.env.VITE_API_URL || "http://localhost:5177/api";
console.log('Using API URL:', API_URL);

export const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json"
  },
  withCredentials: true // Add this to ensure credentials are sent with requests
});

// Add auth token to requests
axiosInstance.interceptors.request.use((config) => {
  const token = authService.getAccessToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Add request logging
axiosInstance.interceptors.request.use(
  (config) => {
    console.log('API Request:', {
      method: config.method?.toUpperCase(),
      url: config.url,
      data: config.data,
      params: config.params,
      headers: config.headers
    });
    return config;
  },
  (error) => {
    console.error('API Request Error:', error);
    return Promise.reject(error);
  }
);

// Add response logging
axiosInstance.interceptors.response.use(
  (response) => {
    console.log('API Response:', {
      status: response.status,
      statusText: response.statusText,
      data: response.data,
      headers: response.headers
    });
    return response;
  },
  async (error) => {
    console.error('API Response Error:', {
      message: error.message,
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data,
      headers: error.response?.headers
    });

    // Handle 401 unauthorized errors by refreshing the token
    if (error.response?.status === 401 && error.config && !error.config._retry) {
      error.config._retry = true;

      try {
        const refreshSuccess = await authService.refreshToken();
        if (refreshSuccess) {
          const token = authService.getAccessToken();
          error.config.headers.Authorization = `Bearer ${token}`;
          return axios(error.config);
        } else {
          // If refresh failed, redirect to login
          window.location.href = '/login';
        }
      } catch (refreshError) {
        console.error('Token refresh failed:', refreshError);
        window.location.href = '/login';
      }
    }

    const customError = {
      ...error,
      message: error.response?.data?.message || error.message || "An error occurred",
      statusCode: error.response?.status || 500,
    };

    return Promise.reject(customError);
  }
);